module.exports = __webpack_public_path__ + "img/ic-logo-christmas.c938010e.svg";